module.exports = __webpack_public_path__ + "assets/img/icon-anli.d95742bd.png";